import { createContext } from "react";
import { IRCASettingsContext } from "./RCASettingsContextInterfaces";

export const initialState: IRCASettingsContext = {
    setRcaSettingsChanges: () => {},
    rcaSettingsChanges: [],
};

export const RCASettingsContext = createContext(initialState);
